export const SET_USERORGS = "SET_USERORGS";
export const SET_USERORG = "SET_USERORG";
export const SET_USERORG_USERS = "SET_USERORG_USERS";
export const USERORG_ERROR = "USERORG_ERROR";

function handleResponse(response) {
  if (response.ok) return response.json();
  return response.json().then((body) => {
    const err = new Error(body.error || response.statusText);
    err.response = body;
    err.status = response.status;
    throw err;
  });
}

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: localStorage.getItem("token"),
});

export const setAll = (results) => ({ type: SET_USERORGS, results });
export const setOne = (result) => ({ type: SET_USERORG, result });
export const setUsers = (results) => ({ type: SET_USERORG_USERS, results });
export const setError = (error) => ({ type: USERORG_ERROR, error });

export function fetchUserOrganisaties() {
  return (dispatch) =>
    fetch("/api/admin/userorganisaties", { headers: authHeaders() })
      .then(handleResponse)
      .then(({ results }) => dispatch(setAll(results)))
      .catch((err) => dispatch(setError(err.message)));
}

export function fetchUserOrganisatie(id) {
  return (dispatch) =>
    fetch(`/api/admin/userorganisaties/${id}`, { headers: authHeaders() })
      .then(handleResponse)
      .then(({ result }) => dispatch(setOne(result)))
      .catch((err) => dispatch(setError(err.message)));
}

export function fetchUserOrganisatieUsers(id) {
  return (dispatch) =>
    fetch(`/api/admin/userorganisaties/${id}/users`, { headers: authHeaders() })
      .then(handleResponse)
      .then(({ results }) => dispatch(setUsers(results)))
      .catch((err) => dispatch(setError(err.message)));
}

export function createUserOrganisatie(data) {
  return () =>
    fetch("/api/admin/userorganisaties", {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify(data),
    }).then(handleResponse);
}

export function updateUserOrganisatie(id, data) {
  return (dispatch) =>
    fetch(`/api/admin/userorganisaties/${id}`, {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify(data),
    })
      .then(handleResponse)
      .then(({ result }) => {
        dispatch(setOne(result));
        return result;
      });
}

export function deleteUserOrganisatie(id, force = false) {
  return () =>
    fetch(`/api/admin/userorganisaties/${id}${force ? "?force=true" : ""}`, {
      method: "DELETE",
      headers: authHeaders(),
    }).then(handleResponse);
}

/**
 * Maak direct een nieuwe gebruiker (locatiebeheerder) aan die aan deze
 * organisatie gekoppeld is. Gebruikt het bestaande /api/signup endpoint.
 */
export function createOrganisatieUser(id, bedrijf, user) {
  return () =>
    fetch("/api/signup", {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify({
        ...user,
        role: "locatiebeheerder",
        bedrijf,
        userOrganisaties: [id],
      }),
    }).then(handleResponse);
}

/**
 * Vraag een tijdelijk token op om als een partner-gebruiker (locatiebeheerder)
 * van deze organisatie in te loggen. Geeft { user, token } terug.
 */
export function impersonateUser(orgId, userId) {
  return () =>
    fetch(`/api/admin/userorganisaties/${orgId}/impersonate/${userId}`, {
      method: "POST",
      headers: authHeaders(),
    }).then(handleResponse);
}

export function addLocationToOrganisatie(id, locationId) {
  return (dispatch) =>
    fetch(`/api/admin/userorganisaties/${id}/locaties`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify({ locationId }),
    })
      .then(handleResponse)
      .then(({ result }) => dispatch(setOne(result)));
}

export function removeLocationFromOrganisatie(id, locationId) {
  return (dispatch) =>
    fetch(`/api/admin/userorganisaties/${id}/locaties/${locationId}`, {
      method: "DELETE",
      headers: authHeaders(),
    })
      .then(handleResponse)
      .then(({ result }) => dispatch(setOne(result)));
}
